// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"46edd49e","160":"6623818f","208":"94b3a439","293":"5fe5037a","516":"c8b56085","519":"bd22378a","917":"95665b92","946":"24f33cb1"}[chunkId] + ".chunk.js";
};